<template>
  <div class="header__wrapper">
    <div class="header__spacer"></div>
    <header class="header" :class="{ sticky: sticky }">
      <div class="container header__container">
        <div class="menu">
          <nav
            class="menu__nav menu__nav--primary"
            aria-label="Navigation principale"
            :class="{ open: isActive }"
          >
            <ul class="menu__items">
              <li
                class="menu__item"
                v-for="(item, idx) in items"
                :key="'menuitem' + idx"
              >
                <router-link class="menu__link" :to="item.to">{{
                  item.title
                }}</router-link>
                <span class="sep"></span>
              </li>
            </ul>
          </nav>
        </div>

        <div class="header__logo">
          <router-link :to="{ name: 'home' }">
            <Logo />
          </router-link>
        </div>
        <div class="menu">
          <div class="menu__burger" @click="isActive = !isActive">
            <BurgerIcon :open="isActive" />
          </div>

          <nav
            class="menu__nav menu__nav--secondary"
            aria-label="Navigation Secondaire"
            :class="{ open: isActive }"
          >
            <ul class="menu__items">
              <li class="menu__item menu__item--account">
                <HeaderAccount />
              </li>
              <li class="menu__item menu__item--account">
                <ui-button @click="goToFavorites" icon="bookmark" text
                  >Favoris</ui-button
                >
              </li>
              <li class="menu__item menu__item--account">
                <HeaderSearch />
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
import HeaderSearch from "./HeaderSearch.vue";
import HeaderAccount from "./HeaderAccount.vue";
import Logo from "./Logo.vue";
import BurgerIcon from "@/components/ui/BurgerIcon.vue";
import UserStore from "@/store/userStore";
import { EventBus } from "@/mixins/event-bus";
export default {
  name: "Header",
  components: {
    BurgerIcon,
    Logo,
    HeaderAccount,
    HeaderSearch,
    UiButton
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      isActive: false,
      sticky: false,
      items: [
        {
          title: "Accueil",
          to: "/"
        },
        {
          title: "Recettes",
          to: "/recettes"
        },
        {
          title: "Catégories",
          to: "/categories"
        }
      ]
    };
  },
  watch: {
    $route() {
      this.isActive = false;
    }
  },
  methods: {
    goToFavorites() {
      if (UserStore.state.logged) {
        this.$router.push({ name: "favorites" });
      } else {
        EventBus.$emit("openLoginModal");
      }
    },
    handleScroll() {
      if (window.scrollY > 40) {
        if (!this.sticky) {
          this.sticky = true;
        }
      } else {
        if (this.sticky) {
          this.sticky = false;
        }
      }
    }
  }
};
</script>

<style lang="scss">
$height: 100px;
.header {
  width: 100%;
  height: $height;
  transition: all 0.3s;
  #app & a {
    color: $black;
  }
  &.sticky {
    height: 60px;
    background: $white;
    box-shadow: $box-shadow;
  }
  display: flex;
  position: fixed;
  top: 0;
  z-index: 200;
  background: $white;
  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  &__spacer {
    height: $height;
    width: 100%;
  }
  &__logo {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 30%);
    font-size: 49px;
    transition: font-size 0.3s;
    .sticky & {
      font-size: 30px;
    }
    svg {
      width: 200px;
    }
    a {
      text-decoration: none;
      color: $black;
    }
  }
}
.menu {
  &__items {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    letter-spacing: 0.03em;
  }
  &__link {
    text-decoration: none;
    color: $black;
  }
  @include breakpoint(lg-min) {
    &__burger {
      display: none;
    }
    &__item {
      display: flex;
      align-items: center;
    }
    &__button {
      border: none;
      padding: 0;
      background: transparent;
    }
    &__item {
      &--account {
        & + & {
          margin-left: 20px;
        }
      }
      &__link {
        text-transform: uppercase;
      }
      .sep {
        margin: 0 10px;
        background-color: $gray;
        width: 1px;
        height: 1em;
      }
      &:last-child .sep {
        display: none;
      }
    }
  }
  @include breakpoint(lg-max) {
    &__nav--primary {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: $white;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translateX(100%);
      transition: transform 0.3s;
      &.open {
        transform: translateX(0);
      }
      .menu__items {
        flex-direction: column;
        align-items: center;
        .sep {
          display: none;
        }
      }
      .menu__item {
        + .menu__item {
          margin-top: 10px;
        }
      }
    }
    &__nav--secondary {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 200;
      background: $white;
      box-shadow: $box-shadow;
      .menu__items {
        display: flex;
        > .menu__item {
          display: flex;
          width: (100% / 3);
        }
        .search,
        .myaccount,
        .btn {
          width: 100%;
        }
        .btn {
          height: 60px;
          justify-content: center;
          flex-direction: column;
          &__icon {
            width: 100%;
            > svg {
              width: 80%;
              margin: auto;
              height: 23px;
              stroke-width: 1.5px;
            }
          }
        }
      }
    }

    &__burger {
      display: flex;
      svg {
        width: 30px;
        height: 30px;
      }
    }
    &__link {
      font-size: 20px;
    }
  }
}
@include breakpoint(lg-max) {
  #app {
    padding-bottom: 50px;
  }
}
</style>
